/* ==============================================================================
   custom.js — このテーマ独自の追加スクリプト
   ------------------------------------------------------------------------------
   ・Impulse 標準の theme.js は変更せず、追加はすべてこのファイルに書く
   ・layout/theme.liquid で theme.js の直後に defer 読み込み
   ============================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------------
     商品スライダー（LP） — sections/lp-product-slider.liquid
     Swiper 本体はセクション側で assets/swiper-bundle.min.js を読み込む
     --------------------------------------------------------------------------- */
  var SLIDER_SELECTOR = '[data-lp-slider]';

  function initProductSlider(section) {
    if (!window.Swiper || section.lpSwiper) return;
    var container = section.querySelector('[data-lp-slider-container]');
    if (!container) return;

    var d = section.dataset;
    // セクションごとの指定を data 属性から読む（未指定なら商品スライダーの既定値）
    var slidesMobile = d.slidesMobile || 'auto';
    // ページャー（丸ドット）とループはセクション側で data 属性を付けたときだけ有効にする
    var pagination = section.querySelector('[data-lp-slider-pagination]');
    var usePagination = d.pagination === 'true' && pagination;
    var useLoop = d.loop === 'true' && container.querySelectorAll('.swiper-slide').length > 1;
    var slidesDesktop = d.slidesDesktop === 'auto' ? 'auto' : (parseInt(d.slidesDesktop, 10) || 4);
    var spaceMobile = d.spaceMobile === undefined ? 12 : parseInt(d.spaceMobile, 10);
    var spaceDesktop = d.spaceDesktop === undefined ? 24 : parseInt(d.spaceDesktop, 10);
    var offsetMobile = d.offsetMobile === undefined ? 22 : parseInt(d.offsetMobile, 10);
    // SP で中央 1 枚・左右を見切れさせるセクション（Box content など）
    var centeredMobile = d.centeredMobile === 'true';

    section.lpSwiper = new window.Swiper(container, {
      // SP: カードを横スクロール（左右に余白を残す）
      slidesPerView: slidesMobile === 'auto' ? 'auto' : parseInt(slidesMobile, 10),
      spaceBetween: spaceMobile,
      slidesOffsetBefore: offsetMobile,
      slidesOffsetAfter: offsetMobile,
      centeredSlides: centeredMobile,
      watchOverflow: true,
      grabCursor: true,
      loop: useLoop,
      navigation: {
        prevEl: section.querySelector('[data-lp-slider-prev]'),
        nextEl: section.querySelector('[data-lp-slider-next]'),
        disabledClass: 'is-disabled'
      },
      pagination: usePagination ? {
        el: pagination,
        clickable: true,
        bulletClass: 'lp-slider-bullet',
        bulletActiveClass: 'is-active'
      } : false,
      breakpoints: {
        // PC: 指定枚数ずつ表示し、矢印で同じ枚数ずつ送る
        769: {
          slidesPerView: slidesDesktop,
          slidesPerGroup: slidesDesktop === 'auto' ? 1 : slidesDesktop,
          spaceBetween: spaceDesktop,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          centeredSlides: false
        }
      }
    });
  }

  function initAllProductSliders(root) {
    var scope = root || document;
    var sections = scope.matches && scope.matches(SLIDER_SELECTOR)
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll(SLIDER_SELECTOR));
    sections.forEach(initProductSlider);
  }

  function destroyProductSlider(section) {
    if (section && section.lpSwiper) {
      section.lpSwiper.destroy(true, true);
      section.lpSwiper = null;
    }
  }

  /* ---------------------------------------------------------------------------
     商品一覧の並び替えを 5 つに絞る
     ---------------------------------------------------------------------------
     Shopify が返す並び替えの選択肢のうち、デザインで指定された5つだけを
     この順番で残す。現在選択中の並び順がこの5つに無い場合は、表示が実際の
     並びとずれないようにその選択肢だけ先頭に残す。
     --------------------------------------------------------------------------- */
  var SORT_ALLOWED = [
    { value: 'created-descending', label: '新着順' },
    { value: 'price-descending', label: '価格の高い順' },
    { value: 'price-ascending', label: '価格の安い順' },
    { value: 'best-selling', label: 'ベストセラー順' },
    { value: 'manual', label: 'おすすめ順' }
  ];

  function trimSortOptions(select) {
    if (!select || select.lpSortTrimmed) return;
    select.lpSortTrimmed = true;

    var current = select.value;
    var existing = {};
    Array.prototype.slice.call(select.options).forEach(function (o) {
      // 同じ value が複数あるときは最初の1つだけ残す
      if (!existing[o.value]) existing[o.value] = o;
    });

    var keep = [];
    if (!SORT_ALLOWED.some(function (a) { return a.value === current; }) && existing[current]) {
      keep.push(existing[current]);
    }
    SORT_ALLOWED.forEach(function (a) {
      var o = existing[a.value];
      if (!o) return;
      o.textContent = a.label;
      keep.push(o);
    });
    if (!keep.length) return;

    select.innerHTML = '';
    keep.forEach(function (o) { select.appendChild(o); });
    select.value = current;
  }

  function initSortOptions(root) {
    var scope = root || document;
    Array.prototype.slice.call(scope.querySelectorAll('select#SortBy, select[name="SortBy"], select[name="sort_by"]'))
      .forEach(trimSortOptions);
  }

  /* ---------------------------------------------------------------------------
     Swiper の遅延読み込み
     ---------------------------------------------------------------------------
     Swiper を使うセクションが無いページでは読み込まない。
     アセットの URL は layout/theme.liquid の script タグの data 属性で渡している。
     --------------------------------------------------------------------------- */
  var swiperLoading = null;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve();
    if (swiperLoading) return swiperLoading;

    var tag = document.querySelector('script[data-swiper-js]');
    if (!tag) return Promise.reject(new Error('swiper asset url not found'));

    swiperLoading = new Promise(function (resolve, reject) {
      var cssHref = tag.getAttribute('data-swiper-css');
      if (cssHref && !document.querySelector('link[href^="' + cssHref.split('?')[0] + '"]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssHref;
        document.head.appendChild(link);
      }
      var js = document.createElement('script');
      js.src = tag.getAttribute('data-swiper-js');
      js.onload = function () { resolve(); };
      js.onerror = reject;
      document.head.appendChild(js);
    });
    return swiperLoading;
  }

  /* ---------------------------------------------------------------------------
     商品カルーセル（最近チェックした商品 / この商品と一緒に見られている商品）
     ---------------------------------------------------------------------------
     テーマ標準セクションのグリッドは非同期で中身が入るため、MutationObserver で
     監視し、しきい値以上の件数になったら Swiper に組み替えて矢印を出す。
     しきい値未満のときはテーマのグリッド表示のままにする。
     --------------------------------------------------------------------------- */
  var CAROUSEL_SECTIONS = '[data-section-type="recently-viewed"], [data-section-type="product-recommendations"], [data-section-type="lp-recommended-products"]';
  var CAROUSEL_MIN = 5;

  function arrowButton(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lp-slider-arrow lp-slider-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? '前へ' : '次へ');
    b.innerHTML = dir === 'prev'
      ? '<svg width="27" height="44" viewBox="0 0 27 44" fill="none" aria-hidden="true"><path d="M17 15L11 22.5L17 30" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg width="27" height="44" viewBox="0 0 27 44" fill="none" aria-hidden="true"><path d="M11 15L17 22.5L11 30" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  /* 矢印の高さを商品画像の中央にそろえる（TOP の「商品スライダー（LP）」と同じ見え方）。
     画像は遅延読み込みで高さが後から変わるため、ResizeObserver で追従する。 */
  function alignCarouselArrows(host, slider) {
    var media = slider.querySelector('.grid-product__image-mask, .grid__item-image-wrapper, .image-wrap');
    if (!media) return;

    var apply = function () {
      var h = host.getBoundingClientRect();
      var m = media.getBoundingClientRect();
      if (!m.height) return;
      host.style.setProperty('--lp-arrow-top', (m.top - h.top + m.height / 2) + 'px');
    };

    apply();
    if (window.ResizeObserver) {
      var ro = new window.ResizeObserver(apply);
      ro.observe(media);
      ro.observe(host);
    } else {
      window.addEventListener('resize', apply);
    }
    window.addEventListener('load', apply);
  }

  function buildCarousel(section, grid) {
    if (!window.Swiper || section.lpCarousel) return;
    var items = Array.prototype.slice.call(grid.children);
    if (items.length < CAROUSEL_MIN) return;

    var host = grid.parentElement;
    var slider = document.createElement('div');
    slider.className = 'lp-carousel__slider swiper';
    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    items.forEach(function (item) {
      item.classList.add('swiper-slide');
      wrapper.appendChild(item);
    });
    slider.appendChild(wrapper);
    grid.style.display = 'none';
    host.appendChild(slider);

    var prev = arrowButton('prev');
    var next = arrowButton('next');
    host.classList.add('lp-carousel__stage');
    host.appendChild(prev);
    host.appendChild(next);
    host.style.position = 'relative';
    alignCarouselArrows(host, slider);

    section.lpCarousel = new window.Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      // SP の左右 22px はコンテナ側の padding で取る（Figma 413:4075）
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      watchOverflow: true,
      grabCursor: true,
      navigation: { prevEl: prev, nextEl: next, disabledClass: 'is-disabled' },
      breakpoints: {
        769: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 24, slidesOffsetBefore: 0, slidesOffsetAfter: 0 }
      }
    });
  }

  function watchCarousel(section) {
    if (section.lpCarouselWatched) return;
    section.lpCarouselWatched = true;
    section.classList.add('lp-carousel');

    var tryBuild = function () {
      var grid = section.querySelector('.grid:not(.visually-invisible)');
      if (grid && grid.children.length >= CAROUSEL_MIN) {
        loadSwiper().then(function () { buildCarousel(section, grid); });
        return true;
      }
      return false;
    };

    if (tryBuild()) return;
    var mo = new MutationObserver(function () {
      if (tryBuild()) mo.disconnect();
    });
    // 「最近チェックした商品」はスクロールで初めて中身が入るため、
    // 監視は打ち切らずページの生存期間中つづける（対象はセクション配下のみ）
    mo.observe(section, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------------------------
     フッターのメールマガジン — snippets/footer-newsletter.liquid
     ---------------------------------------------------------------------------
     SUBSCRIBE を押すとメール登録フォームを開く。
     登録の送信後に戻ってきたとき（成功メッセージ・エラーがあるとき）は
     最初から開いた状態にする。
     --------------------------------------------------------------------------- */
  function initNewsletterToggle(root) {
    var scope = root || document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-newsletter-toggle]')).forEach(function (btn) {
      if (btn.lpNewsletterBound) return;
      btn.lpNewsletterBound = true;

      var wrap = btn.closest('.lp-newsletter');
      if (!wrap) return;

      // 送信結果が表示されているときは開いたままにする
      if (wrap.querySelector('[data-newsletter-open]')) {
        wrap.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }

      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = wrap.querySelector('.footer__newsletter-input');
          if (input) input.focus();
        }
      });
    });
  }

  /* ---------------------------------------------------------------------------
     商品一覧のカート追加ボタン — snippets/product-grid-item.liquid
     ---------------------------------------------------------------------------
     押すと最初の購入可能なバリエーションを1点カートに入れ、カートページへ移動する。
     テーマ標準のクイックショップ（ホバーでモーダル）は使わない。
     --------------------------------------------------------------------------- */
  function cartRoute(key, fallback) {
    if (window.theme && theme.routes && theme.routes[key]) return theme.routes[key];
    return fallback;
  }

  /* 商品一覧のカートボタンの販売期間（snippets/product-grid-item.liquid）
     ページがキャッシュされていても、見ている時点の日時で
     「発売開始前」「受付終了」「カートに入れる」を切り替える */
  function initGridSellPeriod(root) {
    var scope = root || document;
    var now = Math.floor(Date.now() / 1000);
    Array.prototype.slice.call(scope.querySelectorAll('[data-lp-add-to-cart][data-sell-from], [data-lp-add-to-cart][data-sell-until]')).forEach(function (btn) {
      var from = parseInt(btn.getAttribute('data-sell-from'), 10) || 0;
      var until = parseInt(btn.getAttribute('data-sell-until'), 10) || 0;
      var canAdd = btn.getAttribute('data-can-add') === 'true';
      var label = btn.getAttribute('data-label-add') || 'カートに入れる';
      var disabled = false;
      var hidden = false;

      if (from && now < from) {
        label = '発売開始前';
        disabled = true;
      } else if (until && now > until) {
        label = '受付終了';
        disabled = true;
      } else if (!canAdd) {
        // 販売期間中だが売り切れなど → これまでどおりボタンを出さない
        disabled = true;
        hidden = true;
      }

      btn.textContent = label;
      btn.disabled = disabled;
      btn.hidden = hidden;
    });
  }

  function initGridAddToCart(root) {
    var scope = root || document;
    initGridSellPeriod(scope);
    Array.prototype.slice.call(scope.querySelectorAll('[data-lp-add-to-cart]')).forEach(function (btn) {
      if (btn.lpAddBound) return;
      btn.lpAddBound = true;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!id || btn.lpAdding) return;

        btn.lpAdding = true;
        btn.classList.add('is-loading');

        fetch(cartRoute('cartAdd', '/cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (res) {
            if (res.ok) return res.json();
            return res.json().then(function (data) {
              throw new Error(data.description || data.message || '');
            });
          })
          .then(function () {
            window.location.href = cartRoute('cartPage', '/cart');
          })
          .catch(function (err) {
            btn.lpAdding = false;
            btn.classList.remove('is-loading');
            window.alert(err.message || 'カートに追加できませんでした。時間をおいてお試しください。');
          });
      });
    });
  }

  function initCarousels(root) {
    var scope = root || document;

    // custom.recommended-products に登録があるときは自動表示のセクションを隠す
    if (document.querySelector('[data-section-type="lp-recommended-products"]')) {
      var auto = document.querySelector('[data-section-type="product-recommendations"]');
      var autoSection = auto && auto.closest('.shopify-section');
      if (autoSection) autoSection.hidden = true;
    }

    Array.prototype.slice.call(scope.querySelectorAll(CAROUSEL_SECTIONS)).forEach(watchCarousel);
  }

  /* ---------------------------------------------------------------------------
     「最近チェックした商品」のカードに価格を出す
     ---------------------------------------------------------------------------
     このカードは theme.js が JavaScript で組み立てており、テーマ設定
     「検索結果に価格を表示」が OFF だと価格が出ない。カード側の作りは
     そのままに、価格だけ必ず入るように差し替える。
     --------------------------------------------------------------------------- */
  function overrideProductGridItemBuilder() {
    if (!window.theme || typeof theme.buildProductGridItem !== 'function') return;
    if (theme.buildProductGridItem.lpPatched) return;

    var buildImage = theme.buildProductImage;

    var patched = function (items, gridWidth, rowOf, imageSizes) {
      var output = '';
      items.forEach(function (product) {
        var image = buildImage(product, imageSizes);
        var price = theme.Currency.formatMoney(product.price_min, theme.moneyFormat);
        var vendor = theme.settings.predictiveSearchVendor
          ? '<div class="grid-product__vendor">' + product.vendor + '</div>'
          : '';

        output += '<div class="grid__item grid-product ' + gridWidth + ' aos-animate" data-aos="row-of-' + rowOf + '">'
          + '<div class="grid-product__content">'
          + '<a href="' + product.url + '" class="grid-product__link">'
          + '<div class="grid-product__image-mask">' + image + '</div>'
          + '<div class="grid-product__meta">'
          + '<div class="grid-product__title">' + product.title + '</div>'
          + '<div class="grid-product__price">' + price + '</div>'
          + vendor
          + '</div>'
          + '</a>'
          + '</div>'
          + '</div>';
      });
      return output;
    };

    patched.lpPatched = true;
    theme.buildProductGridItem = patched;
  }

  overrideProductGridItemBuilder();

  /* ---------------------------------------------------------------------------
     店舗一覧の都道府県フィルター — sections/lp-store-list.liquid
     ---------------------------------------------------------------------------
     セレクトで選んだ都道府県のカードだけ残す。ページ遷移はしない。
     --------------------------------------------------------------------------- */

  function initStoreFilters(root) {
    var scope = root || document;
    var selects = scope.querySelectorAll('[data-store-filter]');
    Array.prototype.forEach.call(selects, function (select) {
      if (select.lpStoreFilterBound) return;
      select.lpStoreFilterBound = true;

      var grid = document.getElementById(select.getAttribute('aria-controls'));
      if (!grid) return;

      select.addEventListener('change', function () {
        var wanted = select.value;
        var cards = grid.querySelectorAll('.lp-store-card');
        Array.prototype.forEach.call(cards, function (card) {
          card.hidden = wanted !== '' && card.dataset.prefecture !== wanted;
        });

        // STORE / OUTLET のグループは、中の店舗が全部隠れたら見出しごと隠す
        var groups = grid.querySelectorAll('[data-store-group]');
        Array.prototype.forEach.call(groups, function (group) {
          var visible = group.querySelectorAll('.lp-store-card:not([hidden])');
          group.hidden = visible.length === 0;
        });
      });
    });
  }

  /* ---------------------------------------------------------------------------
     中身アイテム一覧のカテゴリータブ — sections/lp-box-item-list.liquid
     ---------------------------------------------------------------------------
     押したタブのカテゴリーを持つアイテムだけ残す。「すべて」は data 値が空。
     各アイテムのカテゴリーは data-categories に JSON の配列で入っている。
     --------------------------------------------------------------------------- */

  function initBoxListTabs(root) {
    var scope = root || document;
    var tabLists = scope.querySelectorAll('.lp-box-list__tabs');
    Array.prototype.forEach.call(tabLists, function (tabList) {
      if (tabList.lpBoxListTabsBound) return;
      tabList.lpBoxListTabsBound = true;

      var tabs = tabList.querySelectorAll('[data-box-list-tab]');
      if (!tabs.length) return;
      var grid = document.getElementById(tabs[0].getAttribute('aria-controls'));
      if (!grid) return;

      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var wanted = tab.getAttribute('data-box-list-tab');

          Array.prototype.forEach.call(tabs, function (other) {
            var active = other === tab;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          Array.prototype.forEach.call(grid.querySelectorAll('.lp-box-list__item'), function (item) {
            var categories = [];
            try {
              categories = JSON.parse(item.getAttribute('data-categories') || '[]');
            } catch (e) {}
            item.hidden = wanted !== '' && categories.indexOf(wanted) === -1;
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------------------
     お問い合わせフォーム — sections/lp-contact-form.liquid
     ---------------------------------------------------------------------------
     ・「確認する」で必須項目の未入力・メールアドレスの形式と不一致を検査する。
       問題があれば各項目の下にメッセージを出して止める（送信しない）
     ・通れば入力内容を並べたモーダル（確認画面）を開き、
       「この内容で送信する」で初めて Shopify に送信する
     --------------------------------------------------------------------------- */

  function initContactForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('.lp-contact__form');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.lpContactBound) return;
      form.lpContactBound = true;
      // ブラウザ標準の吹き出しではなく、下のメッセージで案内する
      form.setAttribute('novalidate', 'novalidate');

      var openBtn = form.querySelector('[data-lp-contact-open]');
      var modal = form.querySelector('[data-lp-contact-modal]');
      var summary = form.querySelector('[data-lp-contact-summary]');
      var submitBtn = form.querySelector('[data-lp-contact-submit]');
      if (!openBtn || !modal || !summary) return;

      var panel = modal.querySelector('.lp-contact-modal__panel');
      var lastFocus = null;
      var confirmed = false;

      function fieldWrap(input) {
        return input.closest('.lp-contact__field');
      }
      function setMessage(input, text) {
        var wrap = fieldWrap(input);
        var msg = wrap && wrap.querySelector('[data-lp-message]');
        if (!msg) return;
        if (text) {
          msg.textContent = text;
          msg.hidden = false;
          wrap.classList.add('is-invalid');
        } else {
          msg.textContent = '';
          msg.hidden = true;
          wrap.classList.remove('is-invalid');
        }
        input.setAttribute('aria-invalid', text ? 'true' : 'false');
      }
      function isEmail(v) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
      }

      function validate() {
        var firstBad = null;
        var fields = form.querySelectorAll('input, select, textarea');
        // 同じ枠内（姓・名など）はまとめて 1 つのメッセージにする
        Array.prototype.forEach.call(form.querySelectorAll('.lp-contact__field'), function (w) {
          w.classList.remove('is-invalid');
          var m = w.querySelector('[data-lp-message]');
          if (m) { m.hidden = true; m.textContent = ''; }
        });

        Array.prototype.forEach.call(fields, function (input) {
          if (input.type === 'hidden' || input.type === 'submit' || input.type === 'button') return;
          var wrap = fieldWrap(input);
          if (!wrap || wrap.classList.contains('is-invalid')) return; // 枠内で既に指摘済み
          var value = (input.value || '').trim();
          var label = input.getAttribute('data-lp-label') || '';
          var error = '';

          if (input.required && value === '') {
            if (wrap.getAttribute('data-lp-group') === 'kana') {
              error = '未入力です。セイ・メイの両方を入力してください。';
            } else if (wrap.getAttribute('data-lp-group') === 'name') {
              error = '未入力です。姓・名の両方を入力してください。';
            } else {
              error = '未入力です。' + label + 'を入力してください。';
            }
          } else if (input.hasAttribute('data-lp-email') && value !== '' && !isEmail(value)) {
            error = 'メールアドレスの形式が正しくありません。';
          } else if (input.hasAttribute('data-lp-email-confirm') && value !== '') {
            var main = form.querySelector('[data-lp-email]');
            if (main && main.value.trim() !== value) error = 'メールアドレスが一致しません。';
          }
          if (error) {
            setMessage(input, error);
            if (!firstBad) firstBad = input;
          }
        });

        if (firstBad) {
          firstBad.focus();
          firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return false;
        }
        return true;
      }

      function buildSummary() {
        summary.innerHTML = '';
        var seen = {};
        Array.prototype.forEach.call(form.querySelectorAll('.lp-contact__field'), function (wrap) {
          var inputs = wrap.querySelectorAll('input, select, textarea');
          if (!inputs.length) return;
          var first = inputs[0];
          if (first.hasAttribute('data-lp-skip-confirm')) return; // 確認用メールは出さない
          var labelEl = wrap.querySelector('.lp-contact__label');
          var label = labelEl ? labelEl.textContent.replace('*', '').trim() : (first.getAttribute('data-lp-label') || '');
          var values = [];
          Array.prototype.forEach.call(inputs, function (i) {
            var v = i.tagName === 'SELECT' ? (i.options[i.selectedIndex] ? i.options[i.selectedIndex].text : '') : i.value;
            v = (v || '').trim();
            if (v) values.push(v);
          });
          if (seen[label]) return;
          seen[label] = true;

          var dt = document.createElement('dt');
          dt.className = 'lp-contact-modal__label';
          dt.textContent = label;
          var dd = document.createElement('dd');
          dd.className = 'lp-contact-modal__value';
          dd.textContent = values.length ? values.join('　') : '（未入力）';
          summary.appendChild(dt);
          summary.appendChild(dd);
        });
      }

      function openModal() {
        buildSummary();
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('lp-contact-modal-open');
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
          if (panel) panel.focus();
        });
      }
      function closeModal() {
        modal.classList.remove('is-open');
        document.body.classList.remove('lp-contact-modal-open');
        modal.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      openBtn.addEventListener('click', function () {
        if (validate()) openModal();
      });
      Array.prototype.forEach.call(form.querySelectorAll('[data-lp-contact-close]'), function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
      // Enter キーなどで直接送信されないようにし、確認画面を通ったときだけ送る
      var submitting = false;
      form.addEventListener('submit', function (e) {
        if (!confirmed || submitting) {
          e.preventDefault();
          if (!confirmed && validate()) openModal();
          return;
        }
        // 二重送信防止。click 中に disabled にすると Chrome が送信を取り消すので、
        // 送信が始まってから無効化する
        submitting = true;
        if (submitBtn) {
          submitBtn.classList.add('is-loading');
          setTimeout(function () { submitBtn.disabled = true; }, 0);
        }
      });
      if (submitBtn) {
        submitBtn.addEventListener('click', function () {
          confirmed = true;
        });
      }

      // 送信後（ページ再読み込み後）はメッセージの位置まで移動する
      var success = form.querySelector('[data-lp-contact-success]');
      if (success) success.scrollIntoView({ block: 'center' });
    });
  }

  /* ---------------------------------------------------------------------------
     長い本文の折りたたみ（VIEW MORE） — sections/text-and-image.liquid
     ---------------------------------------------------------------------------
     現行サイトのトップページ（Js/top.js の viewMore）と同じ動き。
     SP（768px 以下）で本文が 400px を超えるときだけ、本文を 400px で切って
     下端を白くぼかし、VIEW MORE ボタンで全文を開く。PC では何もしない。
     --------------------------------------------------------------------------- */
  var VIEW_MORE_LIMIT = 400;
  var VIEW_MORE_MQ = '(max-width: 768px)';

  function initViewMore(root) {
    var scope = root || document;
    var wraps = scope.querySelectorAll('[data-lp-view-more]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.lpViewMoreBound) return;
      var body = wrap.querySelector('[data-lp-view-more-body]');
      if (!body) return;
      wrap.lpViewMoreBound = true;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lp-view-more__button';
      btn.textContent = 'VIEW MORE';
      btn.hidden = true;
      wrap.appendChild(btn);

      var isOpen = false;

      function apply() {
        var isMobile = window.matchMedia(VIEW_MORE_MQ).matches;
        // いったん制限を外して本来の高さを測る
        body.style.maxHeight = '';
        var needs = isMobile && body.scrollHeight > VIEW_MORE_LIMIT;
        wrap.classList.toggle('has-viewmore', needs);
        btn.hidden = !needs;
        if (!needs) {
          wrap.classList.remove('is-open');
          isOpen = false;
          return;
        }
        body.style.maxHeight = isOpen ? body.scrollHeight + 'px' : VIEW_MORE_LIMIT + 'px';
      }

      btn.addEventListener('click', function () {
        isOpen = !isOpen;
        wrap.classList.toggle('is-open', isOpen);
        body.style.maxHeight = isOpen ? body.scrollHeight + 'px' : VIEW_MORE_LIMIT + 'px';
        btn.textContent = isOpen ? 'CLOSE' : 'VIEW MORE';
      });

      apply();
      window.addEventListener('resize', apply);
      window.addEventListener('load', apply);
    });
  }

  /* ---------------------------------------------------------------------------
     ご利用ガイドの見出し一覧 — sections/lp-guide.liquid
     ---------------------------------------------------------------------------
     本文（page.content）の大見出し .guide_h2 を拾ってページ内リンクの一覧を作る。
     現行サイトの FAQ と同じく、PC は本文の左、SP は本文の上に出す（配置は CSS）。
     ・id のない見出しには guide-N の id を付け、重複した id は付け直す
     ・本文先頭の class なし h2（ページタイトル）は一覧の上のスロットに移す
     --------------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------------
     ギフトオプション（メッセージカード / 熨斗） — snippets/product-gift-options.liquid
     ・「メッセージカード」「熨斗」のどちらを選んだかで下の入力欄を出し分ける
     ・表示していない側は disabled にして、カートへ送らない
     --------------------------------------------------------------------------- */
  function initGiftOptions(root) {
    var scope = root || document;
    var blocks = scope.querySelectorAll('[data-gift-options]');

    Array.prototype.forEach.call(blocks, function (block) {
      if (block.lpGiftOptionsReady) return;
      block.lpGiftOptionsReady = true;

      var type = block.querySelector('[data-gift-options-type]');
      var panels = block.querySelectorAll('[data-gift-options-panel]');
      if (!type) return;

      function sync() {
        Array.prototype.forEach.call(panels, function (panel) {
          var active = panel.getAttribute('data-gift-options-panel') === type.value;
          panel.hidden = !active;
          Array.prototype.forEach.call(panel.querySelectorAll('[data-gift-options-input]'), function (input) {
            input.disabled = !active;
          });
        });
      }

      type.addEventListener('change', sync);
      sync();
    });
  }

  /* ---------------------------------------------------------------------------
     PhotoSwipe のホバー拡大（PC のみ） — snippets/photoswipe-template.liquid
     ・拡大表示（.pswp__zoom-wrap）でマウスを乗せた位置を中心に拡大する
     ・カーソル直下の点が動かないよう、fit 状態の transform から差分を計算して
       zoom-wrap の transform を書き換える（PhotoSwipe 本体の状態は触らない）
     --------------------------------------------------------------------------- */
  function initPhotoswipeHoverZoom() {
    if (window.lpPswpHoverZoomReady) return;
    window.lpPswpHoverZoomReady = true;

    var pointerQuery = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
    // fit 状態（拡大前）の transform と画像の位置。画像が変わるたび取り直す
    var fit = null;

    function matrixOf(el) {
      var value = window.getComputedStyle(el).transform;
      if (!value || value === 'none') return { scale: 1, x: 0, y: 0 };
      try {
        var m = new DOMMatrixReadOnly(value);
        return { scale: m.a || 1, x: m.e || 0, y: m.f || 0 };
      } catch (e) {
        return null;
      }
    }

    function capture(img) {
      var wrap = img.closest('.pswp__zoom-wrap');
      if (!wrap) return null;
      var m = matrixOf(wrap);
      var rect = img.getBoundingClientRect();
      if (!m || !rect.width || !rect.height) return null;
      return {
        img: img,
        wrap: wrap,
        scale: m.scale,
        x: m.x,
        y: m.y,
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        transform: wrap.style.transform
      };
    }

    // 拡大率。原寸を超えてぼやけないよう、fit 倍率から見て 1.6〜3 倍に収める
    function factorFor(state) {
      if (state.scale >= 1) return 1.8;
      return Math.min(3, Math.max(1.6, 1 / state.scale));
    }

    // transform を書き換えるだけなのでレイアウトは起きない。mousemove ごとに直接当てる
    function apply(x, y) {
      if (!fit) return;
      var k = factorFor(fit);
      var tx = fit.x + (x - fit.left) * (1 - k);
      var ty = fit.y + (y - fit.top) * (1 - k);
      fit.wrap.style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0) scale(' + (fit.scale * k) + ')';
    }

    function reset() {
      if (fit) {
        fit.wrap.style.transform = fit.transform;
        fit = null;
      }
      var pswp = document.querySelector('.pswp');
      if (pswp) pswp.classList.remove('pswp--lp-hover-zoom');
    }

    function onMove(evt) {
      if (!pointerQuery.matches) return;

      var img = evt.target && evt.target.closest ? evt.target.closest('.pswp__img') : null;
      if (!img || img.classList.contains('pswp__img--placeholder')) {
        reset();
        return;
      }

      if (!fit || fit.img !== img) {
        reset();
        var pswp = img.closest('.pswp');
        // 開く／閉じるアニメーション中は transform が途中の値なので取らない
        if (!pswp || !pswp.classList.contains('pswp--animated-in')) return;
        pswp.classList.add('pswp--lp-hover-zoom');
        fit = capture(img);
        if (!fit) return;
      }

      apply(evt.clientX, evt.clientY);
    }

    document.addEventListener('mousemove', onMove, { passive: true });
    // ギャラリーを閉じた・画像を送ったときは拡大を解除して取り直す
    document.addEventListener('mouseleave', function (evt) {
      if (evt.target === document || (evt.target.classList && evt.target.classList.contains('pswp'))) reset();
    }, true);
    document.addEventListener('photoswipe:afterChange', reset, true);
    document.addEventListener('click', function (evt) {
      if (evt.target && evt.target.closest && evt.target.closest('.pswp__button')) reset();
    }, true);
    window.addEventListener('resize', reset);
  }

  function initGuideNav(root) {
    var scope = root || document;
    var guides = scope.querySelectorAll('[data-lp-guide]');
    Array.prototype.forEach.call(guides, function (guide) {
      if (guide.lpGuideNavBound) return;
      guide.lpGuideNavBound = true;

      var content = guide.querySelector('[data-lp-guide-content]');
      var nav = guide.querySelector('[data-lp-guide-nav]');
      var list = guide.querySelector('[data-lp-guide-nav-list]');
      var titleSlot = guide.querySelector('[data-lp-guide-title]');
      if (!content || !nav || !list) return;

      // ページタイトルを一覧の上へ
      var first = content.firstElementChild;
      if (titleSlot && first && first.tagName === 'H2' && !first.classList.contains('guide_h2')) {
        titleSlot.appendChild(first);
      }

      var headings = content.querySelectorAll('h2.guide_h2');
      var used = {};
      Array.prototype.forEach.call(headings, function (h, i) {
        var text = (h.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        var id = h.id;
        if (!id || used[id]) {
          id = 'guide-' + (i + 1);
          h.id = id;
        }
        used[id] = true;

        var li = document.createElement('li');
        li.className = 'lp-guide__nav-item';
        var a = document.createElement('a');
        a.className = 'lp-guide__nav-link';
        a.href = '#' + id;
        a.textContent = text;
        li.appendChild(a);
        list.appendChild(li);
      });

      if (list.children.length) {
        nav.hidden = false;
        guide.classList.add('lp-guide--has-nav');
      }
    });
  }

  // 通常読み込み（defer 同士は記述順に実行されるため、DOMContentLoaded 時点で Swiper は定義済み）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllProductSliders(); initCarousels(); initSortOptions(); initNewsletterToggle(); initGridAddToCart(); initStoreFilters(); initBoxListTabs(); initContactForms(); initViewMore(); initGuideNav(); initGiftOptions(); initPhotoswipeHoverZoom(); });
  } else {
    initAllProductSliders();
    initCarousels();
    initSortOptions();
    initNewsletterToggle();
    initGridAddToCart();
    initStoreFilters();
    initBoxListTabs();
    initContactForms();
    initViewMore();
    initGuideNav();
    initGiftOptions();
    initPhotoswipeHoverZoom();
  }
  // 念のため load 後にも未初期化があれば拾う
  window.addEventListener('load', function () { initAllProductSliders(); initCarousels(); initSortOptions(); initNewsletterToggle(); initGridAddToCart(); initStoreFilters(); initBoxListTabs(); initContactForms(); initViewMore(); initGuideNav(); initGiftOptions(); initPhotoswipeHoverZoom(); });

  // テーマエディター: セクションの追加・再描画に追従
  document.addEventListener('shopify:section:load', function (e) {
    initNewsletterToggle(e.target);
    initGridAddToCart(e.target);
    initStoreFilters(e.target);
    initBoxListTabs(e.target);
    initContactForms(e.target);
    initViewMore(e.target);
    initGuideNav(e.target);
    initGiftOptions(e.target);
    var tries = 0;
    (function retry() {
      if (window.Swiper) { initAllProductSliders(e.target); initCarousels(e.target); initSortOptions(e.target); return; }
      if (tries++ < 30) setTimeout(retry, 100);
    })();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroyProductSlider(e.target.querySelector(SLIDER_SELECTOR) || e.target);
  });
})();
